import React, { useEffect, useState } from 'react';
import { apiHolder, apis, inWindow } from 'api';
import classnames from 'classnames/bind';
import styles from './launch.module.scss';
import { useEventObserver } from '@web-common/hooks/useEventObserver';
import { getIn18Text } from 'api';
function reportRemoveLoadingTime() {
    try {
        if (!inWindow()) {
            return;
        }
        const removeLoadingTimeValue = new Date().getTime() - window.pageInitTime;
        const pagePath = location.pathname;
        const pageName = pagePath.replace(/\//g, '');
        const performanceApi = apiHolder.api.requireLogicalApi(apis.performanceImpl);
        performanceApi
            .point({
            statKey: 'page_remove_loading',
            statSubKey: pageName || 'Index',
            value: removeLoadingTimeValue,
            valueType: 1,
        })
            .then();
    }
    catch (ex) {
        console.error('reportRemoveLoadingTime', ex);
    }
}
const systemApi = apiHolder.api.getSystemApi();
const eventApi = apiHolder.api.getEventApi();
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const stepTextMap = {
    0: getIn18Text('GERENZHANGHUJIA'),
    20: getIn18Text('TONGXUNLUJIAZAI'),
    40: getIn18Text('YOUJIANJIAZAIZHONG'),
    60: getIn18Text('XIAOXIJIAZAIZHONG'),
    80: getIn18Text('QITAJIAZAIZHONG'),
    100: getIn18Text('JIAZAIWANCHENG'),
};
const restartApp = () => {
    if (process.env.BUILD_ISELECTRON) {
        systemApi.reLaunchApp();
    }
    else if (inWindow()) {
        history.go();
    }
};
const Launch = ({ from = 'other', onLaunch }) => {
    var _a;
    const isLaunch = from === 'launch';
    const [accoutInited, setAccoutInited] = useState(false);
    const [contactInited, setContactInited] = useState(true);
    const [catalogInited, setCatalogInited] = useState(false);
    const [imInited, setIMInited] = useState(true);
    const [syncSubAccountInited, setSyncSubAccountInited] = useState(process.env.BUILD_ISELECTRON ? false : true);
    const [mailInited, setMailInited] = useState(false);
    const [diskInited, setDiskInited] = useState(true);
    const [percent, setPercent] = useState(0);
    const [intervalTimer, setIntervalTimer] = useState();
    const [timeoutTimer, setTimeoutTimer] = useState();
    const [needRestartApp, setNeedRestartApp] = useState(false);
    const account = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
    const getCurrentPercent = () => {
        const list = [accoutInited, contactInited, mailInited, imInited, syncSubAccountInited];
        const len = list.filter(item => item).length;
        const per = 100 / (list.length + 1);
        return per * (len + 1);
    };
    const launchSuccess = () => {
        setPercent(100);
        clearInterval(intervalTimer);
        clearTimeout(timeoutTimer);
        reportRemoveLoadingTime();
        console.log('[launch] initModule end', isLaunch);
        setTimeout(() => {
            onLaunch && onLaunch();
            eventApi.sendSimpleSysEvent('launchSuccessed');
            if (needRestartApp) {
                setNeedRestartApp(false);
                restartApp();
            }
        }, 500);
    };
    const handleModule = (module) => {
        switch (module) {
            case 'contact':
                setContactInited(true);
                break;
            case 'mail':
                setMailInited(true);
                break;
            case 'catalog':
                setCatalogInited(true);
                break;
            case 'im':
                setIMInited(true);
                break;
            case 'disk':
                setDiskInited(true);
                break;
            case 'account':
                setAccoutInited(true);
                break;
            case 'syncSubAccount':
                setSyncSubAccountInited(true);
                break;
            default:
                break;
        }
    };
    useEventObserver('initModule', {
        name: 'initModule',
        func: ev => {
            var _a;
            console.log('[launch] initModule receive', ev.eventStrData);
            if (ev.eventStrData === 'syncSubAccount' && ((_a = ev.eventData) === null || _a === void 0 ? void 0 : _a.restartApp)) {
                setNeedRestartApp(true);
            }
            ev.eventStrData && handleModule(ev.eventStrData);
        },
    });
    useEventObserver('contactNotify', {
        name: 'contactNotifyInitModule',
        func: ev => {
            var _a, _b;
            if (((ev._account && ev._account === account) || !ev._account) && ((_b = (_a = ev === null || ev === void 0 ? void 0 : ev.eventData) === null || _a === void 0 ? void 0 : _a.syncStatus) === null || _b === void 0 ? void 0 : _b.local)) {
                setContactInited(true);
            }
        },
    });
    useEffect(() => {
        systemApi.switchLoading(false);
        const moduleSet = accountApi.doGetInitModule();
        moduleSet.forEach(module => {
            handleModule(module);
        });
        const timer = window.setTimeout(() => {
            console.error('[launch] initModule timeout');
            launchSuccess();
        }, process.env.LAUNCH_TIMEOUT || 1000 * 15);
        const interTimer = systemApi.intervalEvent({
            eventPeriod: 'mid',
            handler(e) {
                if (e.seq % 2 === 0) {
                    setPercent(per => (per < 80 ? per + 20 : 80));
                }
            },
            seq: 0,
        });
        setTimeoutTimer(timer);
        setIntervalTimer(interTimer);
        return () => {
            clearTimeout(timer);
            systemApi.cancelEvent('mid', interTimer);
        };
    }, []);
    useEffect(() => {
        if (getCurrentPercent() >= 95) {
            launchSuccess();
        }
    }, [catalogInited, contactInited, mailInited, imInited, diskInited, accoutInited, syncSubAccountInited]);
    const wordSeparator = inWindow() && window.systemLang === 'en' ? ' ' : '';
    return (React.createElement("div", { className: styles.launchWrap, "data-test-id": "app-launch-wrap" },
        React.createElement("div", { className: styles.launchContent },
            React.createElement("div", { className: classnames(styles.logo, {
                    [styles.logoEdm]: process.env.BUILD_ISEDM,
                }) }),
            React.createElement("div", { className: styles.name }, process.env.BUILD_ISEDM ? getIn18Text('WANGYIWAIMAOTONG') : getIn18Text('WANGYILINGXIBAN')),
            React.createElement("div", { className: styles.initStep },
                account && (React.createElement("div", { className: styles.initAccount },
                    getIn18Text('ZHENGZAIDENGLUZHANG'),
                    account)),
                React.createElement("div", { className: styles.progressWrap },
                    React.createElement("div", { className: styles.process, style: { width: percent + '%' } })),
                React.createElement("div", { className: styles.txtWrap },
                    React.createElement("div", { className: styles.initTxt }, stepTextMap[percent]),
                    React.createElement("div", { className: styles.initNum }, getIn18Text('JINDU') + wordSeparator + percent + '%'))))));
};
export default Launch;
